<template>
	<div class="chartWrapper chartWrapper--errors">
		<div v-if="ready && mode == 'full'" class="chartContainer chartContainer--errors">
			<div class="chartContainer__toggles">
				<chart-toggles :toggles="toggles" :active="active" @change="toggle($event)" />
			</div>
			<linechart :id="'linechart-errors'" :mobile="mobile" :line-width="chartSettings.lineWidth" :size="chartSettings.size" :margin="chartSettings.margin" :raw-dates="chartData.dates" :lines="lines" :dots="dots" :dot-size="chartSettings.dotSize" :y-type="chartData.yType" :y-unit="chartData.yUnit" :custom-y-range="[0,60]" :show-cursor-line="true" :comments="refinedComments" :date-format="'%B'" />
		</div>

		<!-- Data attribution -->
		<div v-if="mode == 'full'" class="attribution attribution--chart2017">
			<div class="attribution__text">
				<strong>Données&nbsp;:</strong> sondages disponibles sur Wikipédia et <a :href="dataPolitics.url" target="_blank">compilés par Datapolitics</a>. Sur le graphique, les points sont décalés afin de correspondre au temps restant avant le scrutin en 2022.
			</div>
		</div>
	</div>
</template>
<script>
	import { attributeColors, toLocale } from 'global/js/apps.js'
	import Linechart from 'global/components/Linechart'
	import ChartToggles from 'global/components/ChartToggles'
	import colors from 'global/css/_contexte.apps.colors.2.0.scss'

	const urlChartData = 'https://apps.contexte.com/data/ctx-presi-polls/chart_errors.json'
	const dataPoliticsUrl = 'https://github.com/datapolitics/sondages-presidentielles'

	export default {
		name: 'ChartErrors',
		components: { Linechart, ChartToggles },
		props: {
			mobile: {
				type: Boolean,
				default: false,
			},
			mode: {
				type: String,
				default: 'full',
			},
			largeScreen: {
				type: Boolean,
				default: false,
			},
			isDev: {
				type: Boolean,
				default: false,
			},
		},
		data: function() {
			return {
				dataPolitics: {
					url: dataPoliticsUrl,
				},
				active: ['2002', '2012'],
				ready: false,
				raw: {
					chartData: null,
				},
				rwdChartSettings: {
					mobile: {
						margin: { top: 80, right: 162, bottom: 60, left: 75, },
						size: {	width: 800,	height: 1000, },
						lineWidth: 5,
						dotSize: 3,						
					},
					desktop: {
						margin: { top: 40, right: 120, bottom: 40, left: 42, },
						size: {	width: 800 , height: 500,},
						lineWidth: 1.5,
						dotSize: 1.5,					
					},
					largeScreen: {
						margin: { top: 40, right: 120, bottom: 40, left: 42, },
						size: {	width: 800 , height: 600,},
						lineWidth: 1.5,
						dotSize: 4,
					}		
				},
				comments: [
					{
						date: '2022-03-12',
						offset: 0.08,
						text: 'En 2002, les sondages ne se sont rapprochés|du résultat de l’élection qu’après le mois de mars',
						textShort: 'En 2002, les sondages n’approchent|du résultat qu’en mars',
						dataset: '2002',
					},
					{
						date: '2021-12-15',
						offset: 0.45,
						text: 'En 2012, les sondages de janvier étaient déjà|assez proches du résultat de l’élection',
						textShort: 'En 2012, les sondages sont proches|du résultat dès janvier',
						dataset: '2012',
					},
				]
			}
		},
		created() {
			if (this.isDev) console.log(urlChartData)
			fetch(urlChartData, {cache: 'no-store'})
			.then(resp => resp.json())
			.then(json => {
				if (this.isDev) console.log(json)
				this.raw.chartData = json
				this.ready = true
			})
			.catch((err) => {
				console.log(err)
			})
		},
		computed: {
			refinedComments: function() {
				return this.comments.reduce((acc, comment) => {
					if (this.mobile && !!comment.textShort) comment.text = comment.textShort

					if (this.active.includes(comment.dataset)) return acc.concat(comment)
					return acc
				}, [])
			},
			chartData: function() {
				let data = this.raw.chartData
				data['yType'] = 'Décalage moyen'
				data['yUnit'] = '%'
				data.lines = attributeColors(data.lines, this.pallet)
				data.lines.forEach(line => {
					if (line.name == 'Toutes') line.color = colors['dark-grey']
					line.label = line.name
					line.data.reverse()
				})
				let allDots = []
				data.dots.forEach((set, s) => {
					set.data.forEach((dot, d) => {
						let date = new Date(dot.info.originalDate.trim())
						let dateTxt = date.toLocaleString('fr-FR', {
							day: 'numeric',
							month: 'long',
							year: 'numeric',
						})
						dot['html'] = '' + 
							'<div class="tt__score">' +
							'	' + toLocale(dot.y, 3) + '\xa0%' +
							'</div>' +
							'<div class="tt__details">' +
							'   ' + dot.info.company + '<br>' +
							'   ' + dateTxt + ', ' + dot.info.distance + '\xa0jours<br> avant le premier tour<br>' +
							'</div>'
						dot['id'] = 'dot-' + s + '-' + d
						dot['label'] = set.name
						dot.color = this.pallet[s]
						allDots.push(dot)
					})
				})
				data.dots = allDots

				return data
			},
			pallet: function() {
				let pallet = []
				for (let key in colors) {
					if (key.includes('dark') && !key.includes('grey')) pallet.push(colors[key])
				}
				return pallet 
			},
			chartSettings: function() {
				if (this.mobile) return this.rwdChartSettings.mobile
				if (this.largeScreen) return this.rwdChartSettings.largeScreen
				return this.rwdChartSettings.desktop
			},
			toggles: function() {
				return this.chartData.lines.reduce((acc, line) => {
					return acc.concat({
						wording: line.label,
						id: line.label,
					})
				}, [])
			},
			lines: function() {				
				return this.chartData.lines.reduce((acc, line) => {
					if (this.active.includes(line.label)) return acc.concat(line)
					return acc
				}, [])
			},
			dots: function() {
				return this.chartData.dots.reduce((acc, dot) => {
					if (this.active.includes(dot.label)) return acc.concat(dot)
					return acc
				}, [])
			}
		},
		methods: {
			toggle: function(id) {
				if (this.active.includes(id)) {
					if (id != 'Toutes') {
						this.active = this.active.filter(t => t != id)
					}
				} else {
					if (id == 'Toutes') {
						this.active = ['Toutes']
					} else {
						this.active = this.active.filter(t => t != 'Toutes')	
						this.active.push(id)
					}
				}
			}
		}

	}
</script>
<style lang="scss">
	@import 'global/css/contexte.apps.colors';
	.chartWrapper.chartWrapper--errors { 
		.chartToggle {
			flex: 1 1 75px;
		}
		.chartContainer {
			display: flex;
			flex-wrap: wrap;
			margin-left: -.8em;
			margin-right: -.8em;
			margin-bottom: 0 !important;
			width: calc(100% + 1.6em);
			> div {
				margin: 0 .8em 1.5em;
			}
			.chartContainer__toggles {
				flex: 0 0 100px;
			}
			.chart--linechart {
				flex: 1 1 730px;
				padding-left: 0;
			}
		}
	}
	@media screen and (max-width: 1008px)  {
		.chartWrapper.chartWrapper--errors {
			.chartContainer__toggles {
				flex-grow: 1 !important;
			}
		}
	}
</style>